import { render, staticRenderFns } from "./BundleSetCustomerGroup.vue?vue&type=template&id=2e9d568c&scoped=true&"
import script from "./BundleSetCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./BundleSetCustomerGroup.vue?vue&type=script&lang=js&"
import style0 from "./BundleSetCustomerGroup.vue?vue&type=style&index=0&id=2e9d568c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9d568c",
  null
  
)

export default component.exports